import { PostProperties } from "../types";
import image from "../img/lostGemDjStingray.jpg";

const post: PostProperties = {
  id: 14,
  title: "DJ Stingray - Trust Label Party, Flex, Vienna (25.03.2008)",
  content:
    "The undisputed king of electro and founder of Detroit's Urban Tribe playing in Vienna.",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/dj-stingray-trust-label-party-flex-vienna",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Безспорният крал на електрото и основател на детройтския Urban Tribe застава зад пулта във Виена.",
  },
};

export default post;
